(() => {
  if (window.nxInteriorReady) return;
  window.nxInteriorReady = true;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-nx-autosubmit]');
    if (select) select.form.requestSubmit();
    const referenceChoice = event.target.closest('[data-nx-reference-kit], [data-nx-accessory]');
    if (referenceChoice) {
      updateReferenceQuote(referenceChoice.closest('.nx-page'));
      return;
    }
    const variant = event.target.closest('[data-nx-variant]');
    if (!variant) return;
    const option = variant.selectedOptions ? variant.selectedOptions[0] : variant;
    const page = variant.closest('.nx-page');
    const price = page.querySelector('[data-nx-price]');
    if (price) price.textContent = option.dataset.price;
    const compare = page.querySelector('[data-nx-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    const available = option.dataset.available === 'true';
    const button = page.querySelector('[data-nx-add]');
    if (button) {
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Unavailable';
    }
    const status = page.querySelector('[data-nx-status]');
    if (status) status.textContent = option.dataset.stock || (available ? 'Available to order' : 'Currently unavailable');
    const id = page.querySelector('[data-nx-variant-id]');
    if (id) id.value = option.value;
    const sku = page.querySelector('[data-nx-sku]');
    if (sku) sku.textContent = option.dataset.sku || page.querySelector('.nx-product-info h1')?.textContent || '';
    const quantity = page.querySelector('[data-nx-quantity]');
    if (quantity) {
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
    }
    const quote = page.querySelector('[data-nx-quote-link]');
    if (quote && option.dataset.title) {
      const quoteUrl = new URL(quote.href);
      quoteUrl.searchParams.set('product', `${quote.dataset.nxProductTitle} - ${option.dataset.title}`);
      quote.href = quoteUrl.toString();
    }
    if (option.dataset.image) setImage(page, option.dataset.image);
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(null, '', url);
  });
  function setImage(page, src) {
    const img = page.querySelector('.nx-main-image');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = src;
  }
  function updateReferenceQuote(page) {
    if (!page) return;
    const kit = page.querySelector('[data-nx-reference-kit]:checked');
    const quote = page.querySelector('[data-nx-quote-link]');
    if (!kit || !quote) return;
    const quantity = page.querySelector('[data-nx-reference-quantity]');
    const count = Math.max(1, Number.parseInt(quantity?.value, 10) || 1);
    const accessories = [...page.querySelectorAll('[data-nx-accessory]:checked')].map(item => {
      const accessoryQuantity = item.closest('.nx-reference-accessory')?.querySelector('[data-nx-accessory-quantity]');
      return `${item.value} x${Math.max(1, Number.parseInt(accessoryQuantity?.value, 10) || 1)}`;
    });
    const request = `${quote.dataset.nxProductTitle} — ${kit.value} x${count}${accessories.length ? `; accessories: ${accessories.join(', ')}` : ''}`;
    const url = new URL(quote.href, location.origin);
    url.searchParams.set('product', request);
    quote.href = url.toString();
  }
  document.addEventListener('click', async event => {
    const thumb = event.target.closest('[data-nx-image]');
    if (thumb) setImage(thumb.closest('.nx-page'), thumb.dataset.nxImage);
    const share = event.target.closest('[data-nx-share]');
    if (share) {
      const status = share.parentElement.querySelector('[data-nx-share-status]');
      try { await navigator.clipboard.writeText(location.href); status.textContent = 'Link copied'; }
      catch { status.textContent = 'Copy the address from your browser to share this article.'; }
    }
    const productShare = event.target.closest('[data-nx-product-share]');
    if (productShare) {
      const status = productShare.parentElement.querySelector('[data-nx-product-share-status]');
      const productUrl = new URL(location.href);
      productUrl.searchParams.delete('preview_theme_id');
      productUrl.searchParams.delete('variant');
      try {
        await navigator.clipboard.writeText(productUrl.toString());
        status.textContent = 'Product link copied';
      } catch (error) {
        const field = document.createElement('textarea');
        field.value = productUrl.toString();
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        let copied = false;
        try { copied = document.execCommand('copy'); } catch {}
        field.remove();
        status.textContent = copied ? 'Product link copied' : 'Copy the address from your browser to share this product.';
      }
    }
  });
  document.addEventListener('input', event => {
    const referenceQuantity = event.target.closest('[data-nx-reference-quantity], [data-nx-accessory-quantity]');
    if (referenceQuantity) {
      updateReferenceQuote(referenceQuantity.closest('.nx-page'));
      return;
    }
    if (!event.target.matches('[data-nx-download-search]')) return;
    const term = event.target.value.trim().toLowerCase();
    const page = event.target.closest('.nx-page');
    let found = 0;
    page.querySelectorAll('[data-nx-download]').forEach(row => {
      row.hidden = !row.textContent.toLowerCase().includes(term);
      if (!row.hidden) found++;
    });
    page.querySelector('[data-nx-download-empty]').hidden = found > 0;
  });
  function init(root = document) {
    root.querySelectorAll('.nx-product-page').forEach(updateReferenceQuote);
    const params = new URLSearchParams(location.search);
    const field = root.querySelector('[data-nx-product-inquiry]');
    if (field && !field.value && params.get('product')) field.value = params.get('product');
    const application = root.querySelector('select[name="contact[Application]"]');
    if (application && params.get('application')) {
      const requested = params.get('application').toLowerCase();
      const match = [...application.options].find(option => option.text.toLowerCase().includes(requested)) ||
        [...application.options].find(option => requested.includes('factory') && option.text.toLowerCase().includes('factory'));
      if (match) application.value = match.value;
    }
    const body = root.querySelector('[data-nx-inquiry-body]');
    const cart = root.querySelector('[data-nx-cart-quote]');
    if (params.get('from') === 'cart' && body && cart && !body.value) body.value = cart.textContent.trim();
    if (matchMedia('(max-width: 760px)').matches) root.querySelectorAll('.nx-filter details').forEach(d => d.open = false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
